import angular from 'angular';

import PeriodMonthItemModule from './period-month-item';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period.component', [
        PeriodMonthItemModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/calendar-period/component/index.js